import types from '../types/categoryList'
import {Map, List} from 'immutable'

const initialRoot = Map({
  categories: List(),
  isSaving: false,
  error: '',
  lastCategoryFetched: 0,
})

function root(state = initialRoot, action) {
  switch (action.type) {
    case types.FETCH_FIRST_LEVEL_CATEGORIES:
      return state.merge({
        categories: action.payload.categories,
        isSaving: true,
        lastCategoryFetched: action.payload.lastCategoryFetched,
      })
    case types.FETCH_FIRST_LEVEL_CATEGORIES_SUCCESS:
      return state.merge({
        categories: state.get('categories').push(List(action.payload.categories)),
        isSaving: false,
        error: '',
      })
    case types.FETCH_FIRST_LEVEL_CATEGORIES_FAIL:
      return state.merge({
        isSaving: false,
        error: action.payload.error,
      })
    case types.DESELECT_CATEGORY:
      return state.merge({
        categories: action.payload.categories,
        isSaving: false,
        lastCategoryFetched: action.payload.lastCategoryFetched,
      })
    case types.SELECT_CATEGORY:
      return state.merge({
        categories: action.payload.categories,
        isSaving: true,
        lastCategoryFetched: action.payload.lastCategoryFetched,
      })
    case types.SELECT_CATEGORY_SUCCESS:
      return state.merge({
        categories: state.get('categories').push(List(action.payload.categories)),
        isSaving: false,
        error: '',
      })
    case types.SELECT_CATEGORY_FAIL:
      return state.merge({
        isSaving: false,
        error: action.payload.error,
      })
    case types.REMOVE_CATEGORY:
      return state.merge({
        categories: state.get('categories').pop(),
      })
    default:
      return state
  }
}

export default function(state, action) {
  return root(state, action)
}



// WEBPACK FOOTER //
// ./src/sections/yours/reducers/categoryList.js